export const FIRESTORE_LOCATIONS_COLLECTION = "locations";